// CP-812: history-table "Status" text for the three Expense Maintenance actions.
// The descriptive text now lives in the audit `event` attribute (objectData is left blank),
// so these labels are the single source of truth for both the writer
// (Maintenance/operations.js) and the table's dedup logic below.
export const MAINTENANCE_EVENTS = {
  MANUAL_EXPENSE: 'Set Manual Expense to Transmitted',
  DELETE_EXPENSE: 'Set Transmitted Expense to Ready to Bill',
  MISSING_RECEIPT: 'Reload Missing Receipt',
};

// Events treated as a manual maintenance action when deduping the auto "Status Changed"
// rows (CP-787 #3). Includes the legacy 'Maintenance' value so pre-CP-812 history rows
// still dedup correctly.
export const MAINTENANCE_EVENT_LABELS = [...Object.values(MAINTENANCE_EVENTS), 'Maintenance'];
